export default __webpack_public_path__ + "static/media/Banorte-logo.b5d1ed45.png";